<template>
    <div class="defaultButton">
        <van-button v-if="isBtnLoading" disabled :style="{
            borderRadius: radius ? radius : '15px !important',
            padding: btnPadding ? btnPadding : '25px !important',
            background: '#000 !important'
        }">{{ $t('common.loading') }}</van-button>
        <van-button
            v-else
            :disabled="!props.activeStatus"
            @click="props.onClick"
            :style="{
                borderRadius: radius ? radius : '15px',
                padding: btnPadding ? btnPadding : '25px',
                background: (!props.activeStatus && !props.forceGradientWhenDisabled)
                ? '#000'
                : 'linear-gradient(90deg, rgb(1, 73, 72) -18%, rgb(15, 177, 175) 122%)'
            }"
            >
            {{ title }}
        </van-button>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { PropType } from 'vue'

const props = defineProps({
    onClick: {
        type: Function as PropType<() => void>,
        required: false
    },
    title: {
        type: String,
        default: () => ''
    },
    activeStatus: {
        type: Boolean,
        default: false
    },
    radius: {
        type: String,
        default: () => ''
    },
    btnPadding: {
        type: String,
        default: () => ''
    },
    isBtnLoading: {
        type: Boolean,
        default: false
    },
    isColoured: {
        type: Boolean,
        default: false
    },
    forceGradientWhenDisabled: {
        type: Boolean,
        default: false
    }
})

</script>
<style scoped>
.defaultButton>.van-button--default {
    background: linear-gradient(90deg, rgb(1, 71, 70) -18%, rgb(15, 177, 175) 122%);
    color: #ffffffed !important;
    font-weight: 700;
    border: none;
    font-size: 18px;
}

.van-button--normal {
    width: 100%;
}

.van-button--disabled {
    opacity: 0.7 !important;
}
</style>